import React, { PureComponent } from "react";

export default class Slide extends PureComponent {
  constructor(props) {
    super(props);

    this.timer = setInterval(() => {
      this.forceUpdate();
    }, 1800);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const max_show_count = 2;
    const slides = this.props.slideInfo;
    if (!slides) return (<div></div>)
    return (
      <>
        <ul className="scrollWrap">
          {slides.map((t, i) => {
            if (!t.v_index && t.v_index !== 0) {
              t.v_index = i;
            } else {
              t.v_index = t.v_index - 1;
            }

            if (t.v_index < -1) {
              t.v_index = slides.length - max_show_count;
            }

            const offsetTranslate = `translate3d(0, ${t.v_index * 100}%, 0)`;

            const classList =
              t.v_index >= 0 && t.v_index < max_show_count ? "active" : null;

            return (
              <li
                style={{
                  WebkitTransform: offsetTranslate,
                  transform: offsetTranslate
                }}
                className={classList}
              key={i}>
                <span>{t.text}</span>
              </li>
            );
          })}
        </ul>
      </>
    );
  }
}
